export default "__VITE_ASSET__BePKsCv3__"